<template>

    <CoinChip class="user-activity__coin-chip d-flex flex-row align-center">
        <template v-slot:icon>
            <coin-icon :size="12"></coin-icon>
        </template>
        <template v-slot:amount>
            <span class="user-activity__coin-chip__redeem-amount">+
                <slot></slot>
            </span>
        </template>
    </CoinChip>

</template>



<script setup>

import CoinIcon from "@/icons/Coin.vue";
import CoinChip from "@/components/Common/CoinChip.vue";

</script>